export default __webpack_public_path__ + "static/customerSupportHeroBg-a42b99f54a364ca4917bd92bb5a0b6c0.png";